import { PawPrint, BadgeCheck, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const shelters = [
  { name: "KTOZ Kraków", city: "Kraków" },
  { name: "Schronisko LPGK", city: "Legnica" },
  { name: "Koci Azyl", city: "Żagań" },
  { name: "Schronisko", city: "Kielce" },
  { name: "Schronisko", city: "Piotrków Tryb." },
  { name: "Schronisko", city: "Stargard" },
  { name: "Schronisko", city: "Chełm" },
  { name: "Schronisko", city: "Milanówek" },
  { name: "Schronisko Borek", city: "Rzezawa" },
  { name: "Ciapek", city: "Hajnówka" },
  { name: "Schronisko", city: "Sokółka" },
  { name: "Jedno Serce", city: "Szumowo" },
];

// Different rotation angles for polaroid effect
const rotations = [-5, 3, -2, 4, -3, 2, -4, 3, -2, 5, -3, 2];

export const InstagramStory12Polaroid = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#F5F0E8",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          opacity: 0.3,
        }}
      />

      {/* Warm vintage overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(245,240,232,0.95) 0%, rgba(255,250,245,0.9) 100%)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 60px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header - handwritten style */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "12px" }}>
            <Heart style={{ width: "32px", height: "32px", color: "#E57373", fill: "#E57373" }} />
            <Heart style={{ width: "28px", height: "28px", color: "#E57373", fill: "#E57373", opacity: 0.7 }} />
            <Heart style={{ width: "24px", height: "24px", color: "#E57373", fill: "#E57373", opacity: 0.5 }} />
          </div>
          <h1
            style={{
              fontSize: "52px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
            }}
          >
            Nasze <span style={{ color: "#4E8A6E" }}>12</span> zweryfikowanych
          </h1>
          <p style={{ fontSize: "36px", fontWeight: 600, color: "#6B8A7A", margin: "8px 0 0" }}>
            schronisk 📸
          </p>
        </div>

        {/* Polaroid cards grid */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "16px",
            alignContent: "center",
            justifyItems: "center",
          }}
        >
          {shelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "#FFFFFF",
                borderRadius: "4px",
                padding: "12px 12px 28px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)",
                transform: `rotate(${rotations[i]}deg)`,
                width: "280px",
              }}
            >
              {/* Polaroid "photo" area */}
              <div
                style={{
                  background: "linear-gradient(135deg, #4E8A6E 0%, #6BAF8D 100%)",
                  borderRadius: "2px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                }}
              >
                <BadgeCheck style={{ width: "40px", height: "40px", color: "#FFFFFF" }} />
              </div>
              {/* Polaroid caption area */}
              <div style={{ textAlign: "center" }}>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#2D5A3D",
                    display: "block",
                    lineHeight: 1.2,
                  }}
                >
                  {shelter.name}
                </span>
                <span style={{ fontSize: "16px", fontWeight: 500, color: "#8B7355" }}>
                  📍 {shelter.city}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <p style={{ fontSize: "30px", fontWeight: 700, color: "#4E8A6E", margin: "0 0 20px" }}>
            Sprawdź czego potrzebują! ✨
          </p>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "28px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
